import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex-composition-helpers'
import FormLayout from '../common/FormLayout.vue'
import ProjectCreationSection from './ProjectCreationSection.vue'
import ProjectsList from './ProjectsList.vue'
import { useJobBottomSheetStatesStore } from '@/components/jobs/jobBottomSheetStatesStore'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsPagination from '@/components/vision/VsPagination.vue'
import VsSnackbar from '@/components/vision/VsSnackbar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectSelectionPage',
  props: {
    jobId: null,
    ownerId: null
  },
  emits: ['job-added-success', 'job-added-failure', 'dismiss'],
  setup(__props: any, { emit }) {

const props = __props as {
  jobId: number
  ownerId: string
}





// Store access
const store = useStore()
const jobBottomSheetStatesStore = useJobBottomSheetStatesStore()

// Computed properties
const getTotalPages = computed(() => store.getters['projects/getTotalPages'])
const currentPage = computed(() => store.getters['projects/getCurrentPage'])
const projectError = computed(() => store.getters['projects/getError'])
const addJobError = computed(() => store.getters['projects/getAddJobError'])

const totalPages = computed(() => getTotalPages.value(props.ownerId))

const page = computed({
  get: () => currentPage.value,
  set: (newValue) => store.commit('projects/UPDATE_CURRENT_PAGE', newValue),
})

const isSnackbarVisible = computed({
  get: () => !!projectError.value,
  set: (newValue) => {
    if (!newValue) {
      store.commit('projects/CLEAR_ERROR_PROJECT')
    }
  },
})

// Methods
const onSave = async (projectName: string) => {
  const projectId = await store.dispatch('projects/createProject', {
    projectName,
    jobId: props.jobId,
    ownerId: props.ownerId,
  })

  if (!projectError.value && !addJobError.value) {
    emit('job-added-success', projectId)
  } else if (addJobError.value) {
    emit('job-added-failure', 'addToNewProjectError')
  }

  jobBottomSheetStatesStore.setJobBottomSheetStates({
    isProjectBottomSheetVisible: false,
  })
}

const onSelect = async (projectId: string) => {
  await store.dispatch('projects/addJobToProject', {
    projectId,
    jobId: props.jobId,
  })

  if (!projectError.value && !addJobError.value) {
    emit('job-added-success', projectId)
  } else if (addJobError.value) {
    emit('job-added-failure', 'addToExistingProjectError')
  }

  jobBottomSheetStatesStore.setJobBottomSheetStates({
    isProjectBottomSheetVisible: false,
  })
}

const dismiss = () => {
  emit('dismiss')
  jobBottomSheetStatesStore.setJobBottomSheetStates({
    isProjectBottomSheetVisible: false,
  })
}

// Lifecycle hooks
onMounted(() => {
  store.dispatch('projects/fetchProjects')
})

return { __sfc: true,props, emit, store, jobBottomSheetStatesStore, getTotalPages, currentPage, projectError, addJobError, totalPages, page, isSnackbarVisible, onSave, onSelect, dismiss, FormLayout, ProjectCreationSection, ProjectsList, VsWrapper, VsPagination, VsSnackbar }
}

})